// extracted by mini-css-extract-plugin
export default {"container":"downfall_container__2isSB","gameContainer":"downfall_gameContainer__2UF0c","points":"downfall_points__2CNEU"};